import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';

import { FloodJobsProvider } from '@/features/analytics/context/FloodJobsContext';
import { store } from '@/stores';

import './i18n';
import '@/features/map/utils/applyVietmapMapPrototypeShim';
import App from './app/App';
import './index.css';
import '@vietmap/vietmap-gl-js/dist/vietmap-gl.css';

// Redux + FloodJobs: bọc ở root để mọi layout dùng cùng một React Context (tránh lỗi provider).
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ReduxProvider store={store}>
      <FloodJobsProvider>
        <App />
      </FloodJobsProvider>
    </ReduxProvider>
  </StrictMode>,
);
